import { defineStore } from "pinia";
import { isObject, cloneDeep, merge } from "lodash";
import { useUser } from "./user";
import { matchesPropertyInsensitive } from "@/utilities/functions/matchesPropertyInsensitive";
import api from "@/api";

export const useSettings = defineStore("settings", {
    state: () => {
        return {
            platformId: 'HDHome',
            platformIdHeader: import.meta.env.VITE_PLATFORM_HEADER,
            platformFrontendId: import.meta.env.VITE_CLIENT_ID,
            authInitialized: false,
            mode: import.meta.env.MODE
        };
    },
    actions: {
    },
    getters: {
      cleanObj () {
        return (obj) =>  {
          return cleanObj(obj)
        }
      },
      getUserRoleId (state){
        return (as) =>  {
          if( useUser().roles.length == 0 ) return 1
          return useUser().roles.find( matchesPropertyInsensitive("roleName", as) )?.roleId;
        }
      },
    },
});

const cleanObj = ( obj ) => {
  Object.keys(obj).map(k => {
    if( isObject(obj[k]) ){
      cleanObj(obj[k])
      if( Object.keys(obj[k]).length === 0 ) delete obj[k]
    }
    else{
      Object.keys(obj).map(k => obj[k] == null ? delete obj[k] : obj[k] );
    }
  })
  return obj
}
